import React from 'react'
import { Link } from 'react-router-dom'

function Futurofish() {
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/semiverticals" className="block py-1 pl-4 hover:underline mt-6">Semi Verticals -</Link>
           <span className="block py-1 pl-4 mt-6">FUTURO</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/futurofish.jpg" alt="FUTURO" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">FUTURO</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">The most complete and flexible self-service solution for food retail.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">FUTURO semi-verticals, the specialist display line for self-service. Specialized models<span className=' text-black'> designed in 316 stainless steel,</span>  maximum product display capacity with the optimal temperature control and visibility for your packaged goods of dry codfish.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl lg:text-2xl opacity-90">PACKED SALTED FISH<span className=' text-blue-400'>-1… +5 °C</span> (3M1)</p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">CO2 | Glycol</p>
         </div>


         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/fishfuturo.png" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Ready for pre-packaged dry salted fish.</p>
    <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl  font-thin opacity-90 mt-6">
  Solid construction in 316 stainless steel, more resistance to corrosion (salt and brine), more hygienic and easy to clean.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  Available in 3 widths, 80 cm, 97 cm and 110 cm.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  Models available in 3 heights, 120 cm, 130 cm and 160 cm - up to 4 display levels for maximum capacity.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  Tiltable shelves in glass or stainless steel, with undershelf LED lighting.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  Semi-verticals for linear or gondola arrangement.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  LED lightning of high brightness and high energy efficiency.
  </li>
</ul>
</div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Self-Service with greater energy savings!</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Chilled models with optional slide front doors, allowing up to 50% of energy savings.</div>
</div>
 {/* ✅ Image Wrapper */}
 <div className="w-full md:w-1/2">
                 <img src="/images/futurofish1.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
         </div>
    

     </div>
    
  
        </div>
      )
    }
export default Futurofish